import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Text } from 'pcln-design-system'
import { locales, getLocalized, validateLocale } from './helpers/locales.js'
import deprecatedPropType from './helpers/deprecatedPropType/deprecatedPropType'

const DayName = styled(Box)`
  display: inline-block;
  vertical-align: top;
  text-transform: capitalize;
  padding: 2px 0;
  text-align: center;
`

class DayNames extends PureComponent {
  render() {
    const requestedLocale = getLocalized(this.props.locale)
    const locale = validateLocale(this.props.locale)
    const validLocale = validateLocale(locale)
    let weekStartsOn
    if (this.props.locale) {
      weekStartsOn = (locales[validLocale].options && locales[validLocale].options.weekStartsOn) || 0
    } else {
      // Deprecated feature. Do not use....
      weekStartsOn = this.props.startsWithSunday ? 0 : 1
    }

    const dayBuilder = (format) => {
      // valid formats are:
      // narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      // short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      // abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      // wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const days = []
      for (let d = 0; d < 7; d++) {
        days.push(requestedLocale.day(d, { width: format }))
      }

      while (weekStartsOn > 0) {
        days.push(days.shift())
        weekStartsOn--
      }
      return days
    }

    return (
      <Box pt={2}>
        {dayBuilder('abbreviated').map((name, index) => (
          <DayName key={name} width={1 / 7} data-testid={`day-name-${index}`}>
            <Text fontSize={0} color='text.light'>
              {name}
            </Text>
          </DayName>
        ))}
      </Box>
    )
  }
}

DayNames.propTypes = {
  startsWithSunday: deprecatedPropType('locale'),
  locale: PropTypes.string,
}

export default DayNames
